import { render, staticRenderFns } from "./FeaturedProductCard.vue?vue&type=template&id=21dd1d40&scoped=true"
import script from "./FeaturedProductCard.vue?vue&type=script&lang=js"
export * from "./FeaturedProductCard.vue?vue&type=script&lang=js"
import style0 from "./FeaturedProductCard.vue?vue&type=style&index=0&id=21dd1d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dd1d40",
  null
  
)

export default component.exports